import { render, staticRenderFns } from "./ImportantNews.vue?vue&type=template&id=3c6ed458&scoped=true"
import script from "./ImportantNews.vue?vue&type=script&lang=js"
export * from "./ImportantNews.vue?vue&type=script&lang=js"
import style0 from "./ImportantNews.vue?vue&type=style&index=0&id=3c6ed458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ed458",
  null
  
)

export default component.exports